/**
 * @typedef {import("react").CSSProperties} CSSProperties
 */

/**
 *
 * @param {boolean} hasReceivedHandshakeFromPaymentIframe
 * @param {boolean} hasExceededNumberOfHandshakeAttempts
 * @returns {boolean}
 */
export const getDisplayLoadingAnimation = (
    hasReceivedHandshakeFromPaymentIframe,
    hasExceededNumberOfHandshakeAttempts,
) => {
    const displayLoadingAnimation =
        !hasReceivedHandshakeFromPaymentIframe &&
        !hasExceededNumberOfHandshakeAttempts;

    return displayLoadingAnimation;
};

/**
 *
 * @param {boolean} hasReceivedHandshakeFromPaymentIframe
 * @param {boolean} hasExceededNumberOfHandshakeAttempts
 * @returns {boolean}
 */
export const getDisplayErrorMessage = (
    hasReceivedHandshakeFromPaymentIframe,
    hasExceededNumberOfHandshakeAttempts,
) => {
    const displayErrorMessage =
        !hasReceivedHandshakeFromPaymentIframe &&
        hasExceededNumberOfHandshakeAttempts;

    return displayErrorMessage;
};

/**
 *
 * @description The visibility property allows us to ensure the payment iframe
 * takes up as much space as it would during normal document flow which ensures
 * that we can get accurate height information form it while allowing us to
 * only display the cc fields when the payment iframe is ready to handle
 * submission attempts.
 * @param {boolean} hasReceivedHandshakeFromPaymentIframe
 * @returns {CSSProperties}
 */
export const getStyleOfPaymentIframe = (
    hasReceivedHandshakeFromPaymentIframe,
) => {
    /** @type {CSSProperties['visibility']} */
    const visibilityOfPaymentIframe = hasReceivedHandshakeFromPaymentIframe
        ? "visible"
        : "hidden";
    const visibility = visibilityOfPaymentIframe;
    const styleOfPaymentIframe = {
        visibility,
    };

    return styleOfPaymentIframe;
};

/**
 *
 * @description Ensures that the UI does not "jump" on when the initial resize
 * message is sent to the host application.
 * @param {string} defaultHeightOfPaymentIframe
 * @returns {CSSProperties}
 */
export const getStyleOfPaymentIframeContainer = (
    defaultHeightOfPaymentIframe,
) => {
    const height = defaultHeightOfPaymentIframe;
    const styleOfPaymentIframeContainer = {
        height,
    };

    return styleOfPaymentIframeContainer;
};
